document.addEventListener('DOMContentLoaded',()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-leather-edit]').forEach(section=>{
    const track=section.querySelector('.leather-edit-track');
    if(!track||reduce.matches||track.dataset.cinematicReady)return;
    const originals=[...track.children];
    if(originals.length<2)return;
    track.dataset.cinematicReady='true';
    originals.forEach((card,index)=>{
      card.style.setProperty('--orbit-index',index);
      const clone=card.cloneNode(true);
      clone.setAttribute('aria-hidden','true');
      clone.removeAttribute('role');
      clone.querySelectorAll('a,button,input,select,textarea').forEach(el=>el.tabIndex=-1);
      clone.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
      track.appendChild(clone);
    });
    let offset=0,last=0,cycle=0,frame=0;
    const measure=()=>{
      const first=originals[0],lastCard=originals[originals.length-1];
      const styles=getComputedStyle(track);
      const gap=parseFloat(styles.columnGap||styles.gap)||0;
      cycle=lastCard.offsetLeft+lastCard.offsetWidth-first.offsetLeft+gap;
      offset=cycle?offset%cycle:0;
    };
    const tick=time=>{
      if(!last)last=time;
      const elapsed=Math.min(time-last,50);
      last=time;
      if(cycle){offset=(offset+elapsed*.12)%cycle;track.style.transform=`translate3d(${-offset}px,0,0)`}
      frame=requestAnimationFrame(tick);
    };
    measure();
    window.addEventListener('resize',measure,{passive:true});
    section.querySelectorAll('img').forEach(img=>{if(!img.complete)img.addEventListener('load',measure,{once:true})});
    frame=requestAnimationFrame(tick);
    reduce.addEventListener('change',event=>{if(event.matches){cancelAnimationFrame(frame);track.style.transform='none'}});
  });
});
